<div class="eventList-head flex-wrap gap-2">
  <div class="d-flex align-items-center justify-content-between gap-3">
    <div
      class="d-flex align-items-center gap-3"
      style="cursor: pointer"
      (click)="goBack()"
    >
      <img src="assets/images/Buttons/arrow-left.svg" class="back-icon" />
      <div class="header-text eventList-text">Reports</div>
    </div>

    <div
      style="cursor: pointer"
      class="d-flex gap-3 align-items-center status-text"
      *ngIf="userRoles.share"
      [ngStyle]="{
        opacity:
          activeTab == 'Reports dashboard' ||
          activeTab == 'Diversity' ||
          activeTab == 'Attendance trend analysis'
            ? 0
            : 1,
        'pointer-events': activeTab == 'Reports dashboard' ? 'none' : 'auto',
      }"
    >
      <div class="status-dropdown-container">
        <div class="status-display" (click)="toggleStatusDropdown($event)">
          <svg
            width="17"
            height="13"
            viewBox="0 0 17 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.7502 6.04918L7.75016 0.75L7.75016 3.75C0.75 5.25 0.75 12.25 0.75 12.25C0.75 12.25 3.75 8.25 7.75016 8.75L7.75016 11.85L15.7502 6.04918Z"
              stroke="white"
              stroke-width="1.5"
              stroke-linejoin="round"
            />
          </svg>
          Export as
        </div>

        <div
          class="status-dropdown-menu"
          [class.show]="showExportDropdown"
          (click)="$event.stopPropagation()"
        >
          <div
            class="status-option"
            (click)="exportTable('csv')"
            [class.disabled]="isExporting"
          >
            CSV file
          </div>
          <div
            class="status-option"
            (click)="exportTable('pdf')"
            [class.disabled]="isExporting"
          >
            PDF
          </div>
        </div>

        <div
          class="status-backdrop"
          *ngIf="showExportDropdown"
          (click)="closeStatusDropdown()"
        ></div>
      </div>
    </div>
  </div>

  <div class="report-segment">
    <div class="report-tab-segment">
      <button
        *ngIf="userRoles.reportDashboard"
        [class.active]="activeTab === 'Reports dashboard'"
        (click)="setActive('Reports dashboard')"
      >
        Reports dashboard
      </button>

      <button
        *ngIf="userRoles.eventReport"
        [class.active]="activeTab === 'Event report'"
        (click)="setActive('Event report')"
      >
        Event report
      </button>

      <button
        *ngIf="userRoles.eventTypeReport"
        [class.active]="activeTab === 'Event type report'"
        (click)="setActive('Event type report')"
      >
        Event type report
      </button>

      <button
        *ngIf="userRoles.managerActivity"
        [class.active]="activeTab === 'Manager activity'"
        (click)="setActive('Manager activity')"
      >
        Manager activity
      </button>
      <button
        *ngIf="userRoles.industryPartner"
        [class.active]="activeTab === 'Industry partner'"
        (click)="setActive('Industry partner')"
      >
        Industry partner
      </button>

      <button
        *ngIf="userRoles.schoolEngagement"
        [class.active]="activeTab === 'School engagement'"
        (click)="setActive('School engagement')"
      >
        School engagement
      </button>
      <button
        [class.active]="activeTab === 'Diversity'"
        (click)="setActive('Diversity')"
      >
        Diversity
      </button>
      <button
        [class.active]="activeTab === 'Attendance trend analysis'"
        (click)="setActive('Attendance trend analysis')"
      >
        Attendance trend analysis
      </button>
    </div>

    <div
      class="filter-items"
      [ngStyle]="{
        'grid-template-columns':
          activeTab === 'MCC event partner' ||
          activeTab === 'Event type report' ||
          activeTab === 'Attendance trend analysis'
            ? '1fr 1fr 1fr 200px'
            : activeTab === 'Manager activity'
              ? '1fr 1fr 1fr 200px'
              : activeTab === 'Industry partner' ||
                  activeTab === 'School engagement'
                ? '1fr 1fr 1fr 1fr 200px'
                : activeTab === 'Diversity'
                  ? '1fr 1fr 200px'
                  : '1fr 1fr 1fr 1fr 200px',
      }"
    >
      <div class="date-range-inputs">
        <div class="date-inputs-wrapper">
          <div class="form-group w-100">
            <app-input
              context="Normal"
              placeholder="From"
              type="date"
              [(ngModel)]="startDate"
              (dateChange)="onStartDateChange($event)"
              label="Start date"
              [disableWeekends]="true"
              [labelGap]="true"
              [customErrorMessages]="{ required: 'Please enter a start date' }"
            >
            </app-input>
          </div>

          <div class="form-group w-100">
            <app-input
              context="Normal"
              placeholder="To"
              type="date"
              [(ngModel)]="endDate"
              label="End date"
              [labelGap]="true"
              (dateChange)="onEndDateChange($event)"
              [min]="getMinEndDate()"
              [disableWeekends]="true"
              [customErrorMessages]="{
                required: 'Please enter an end date',
                dateRange: 'End date must be after start date',
              }"
            >
            </app-input>
          </div>
        </div>
      </div>

      <div
        *ngIf="activeTab === 'School engagement'"
        class="dashboard-multi-select"
      >
        <app-multi-select
          [label]="'Year'"
          placeholder="Select years"
          [options]="yearDropdownList"
          [(ngModel)]="selectedYears"
          (selectionChange)="onYearChange($event)"
          [required]="false"
          [searchable]="true"
          [showCheckBox]="true"
        >
        </app-multi-select>
      </div>

      <div
        [ngClass]="
          activeTab === 'Diversity'
            ? 'dashboard-multi-select region-full-width'
            : 'dashboard-multi-select'
        "
      >
        <app-multi-select
          [label]="'Region'"
          placeholder="Select regions"
          [options]="regions"
          [(ngModel)]="selectedMccPartners"
          (selectionChange)="onRegionChange($event)"
          [required]="false"
          [searchable]="true"
          [showCheckBox]="true"
        >
        </app-multi-select>
      </div>

      <!-- Event Type Multi Select -->
      <div
        class="dashboard-multi-select"
        *ngIf="
          activeTab !== 'Event type report' &&
          activeTab !== 'Manager activity' &&
          activeTab !== 'Diversity' &&
          activeTab !== 'Industry partner'
        "
      >
        <app-multi-select
          [label]="'Event type'"
          placeholder="Select event types"
          [options]="eventTypes"
          [(ngModel)]="selectedEventTypes"
          (selectionChange)="onEventTypeChange($event)"
          [required]="false"
          [searchable]="true"
          [showCheckBox]="true"
        >
        </app-multi-select>
      </div>

      <!-- Event Manager Multi Select -->
      <div
        class="dashboard-multi-select"
        *ngIf="
          activeTab !== 'MCC event partner' &&
          activeTab !== 'School engagement' &&
          activeTab !== 'Diversity' &&
          activeTab !== 'Attendance trend analysis'
        "
      >
        <app-multi-select
          [label]="'Event manager'"
          placeholder="Select event managers"
          [options]="eventManagers"
          [(ngModel)]="selectedManagers"
          (selectionChange)="onManagerChange($event)"
          [required]="false"
          [searchable]="true"
          [showCheckBox]="true"
        >
        </app-multi-select>
      </div>

      <!-- MCC Partner Multi Select (only for Industry partner) -->
      <div
        *ngIf="activeTab === 'Industry partner'"
        class="dashboard-multi-select"
      >
        <app-multi-select
          [label]="'MCC partner'"
          placeholder="Select MCC partners"
          [options]="mccPartners"
          [(ngModel)]="selectedMccPartnersList"
          (selectionChange)="onMccPartnerChange($event)"
          [required]="false"
          [searchable]="true"
          [showCheckBox]="true"
        >
        </app-multi-select>
      </div>

      <div
        [ngClass]="activeTab === 'Diversity' ? 'apply-filter-down' : 'apply-filter-container'"
      >
        <div class="apply-filter-item">
          <button
            class="apply-filter"
            (click)="applyFilter()"
            [disabled]="
              !startDate ||
              !endDate ||
              (endDate <= startDate && activeTab !== 'School engagement')
            "
          >
            Apply filters
          </button>
          <button class="reset-button" (click)="resetFilter()">
            <svg
              width="9"
              height="9"
              viewBox="0 0 9 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 1L1 8M8 8L1 1"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            Reset
          </button>
        </div>
      </div>
    </div>

    <div
      [style.opacity]="loading ? 0 : 1"
      [style.height]="loading ? 0 : 'auto'"
      style="transition: 0.5s ease"
    >
      <div class="summary-overview" *ngIf="activeTab === 'Reports dashboard'">
        <div class="card bg-orange card-bg-pattern2">
          <div class="card-content">
            <div class="w-100">
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="card-title">Total events</div>
                <div>
                  <img
                    src="assets/images/card-go.svg"
                    alt="Users"
                    class="icon-round"
                  />
                </div>
              </div>
              <div class="d-flex align-items-center gap-3">
                <img
                  src="assets/icons/dashboard/events.svg"
                  alt="events"
                  class="icon-round"
                />
                <div class="card-value">
                  {{ summaryData?.totalEvents || 0 }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card bg-blue">
          <div class="card-content">
            <div>
              <div class="card-title">Total attendees registered</div>
              <div class="d-flex align-items-center gap-3">
                <img
                  src="assets/icons/dashboard/users.svg"
                  alt="events"
                  class="icon-round"
                />
                <div class="card-value">{{ summaryData?.totalAttendees }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="card bg-yellow card-bg-pattern2">
          <div class="card-content">
            <div>
              <div class="card-title">Total schools engaged</div>
              <div class="d-flex align-items-center gap-3">
                <img
                  src="assets/icons/dashboard/school.svg"
                  alt="events"
                  class="icon-round"
                />
                <div class="card-value">
                  {{ summaryData?.totalSchools || 0 }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card bg-red">
          <div class="card-content">
            <div>
              <div class="card-title">Total partners engaged</div>
              <div class="d-flex align-items-center gap-3">
                <img
                  src="assets/icons/dashboard/partners.svg"
                  alt="events"
                  class="icon-round"
                />
                <div class="card-value">
                  {{ summaryData?.totalPartners || 0 }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="events-lists"
        [ngClass]="activeTabClass"
        *ngIf="
          activeTab !== 'Event type report' &&
          activeTab !== 'Diversity' &&
          activeTab !== 'Attendance trend analysis'
        "
      >
        <div class="graph-header">
          <h2>{{ titleMap[activeTab] }}</h2>
          <h4 *ngIf="dataLoaded && appliedStartDate && appliedEndDate">
            {{ appliedStartDate | date: "dd/MM/yyyy" }} -
            {{ appliedEndDate | date: "dd/MM/yyyy" }}
          </h4>
        </div>

        <div *ngIf="!showNoDataTopBarChart && topBarChart">
          <app-universal-chart [options]="topBarChart"></app-universal-chart>
        </div>

        <div class="no-data-message" *ngIf="showNoDataTopBarChart">
          <p>No data available</p>
        </div>
      </div>

      <div *ngIf="activeTab === 'Event type report'">
        <div *ngIf="activeTab === 'Event type report'">
          <div class="events-lists" [ngClass]="activeTabClass">
            <div class="graph-header">
              <h2>{{ titleMap[activeTab] }}</h2>
              <h4
                *ngIf="
                  dataLoaded &&
                  appliedStartDate &&
                  appliedEndDate &&
                  activeTab + '' !== 'School engagement'
                "
              >
                {{ appliedStartDate | date: "dd/MM/yyyy" }} -
                {{ appliedEndDate | date: "dd/MM/yyyy" }}
              </h4>
            </div>
            <div *ngIf="!showNoDataTopBarChart && topBarChart">
              <app-universal-chart
                [options]="topBarChart"
              ></app-universal-chart>
            </div>

            <div class="no-data-message" *ngIf="showNoDataTopBarChart">
              <p>No data available</p>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="activeTab === 'Diversity'">
        <div class="diversity-container">
          <div class="chart-row">
            <div class="events-lists" [ngClass]="activeTabClass">
              <div class="graph-header">
                <h2>Ethnicity distribution</h2>
                <h4
                  *ngIf="dataLoaded && appliedStartDate && appliedEndDate"
                  class="h4-class"
                >
                  {{ appliedStartDate | date: "dd/MM/yyyy" }} -
                  {{ appliedEndDate | date: "dd/MM/yyyy" }}
                </h4>
              </div>
              <div *ngIf="showEthnicityDistributionChart && diversityPieChart">
                <app-universal-chart
                  [options]="diversityPieChart"
                ></app-universal-chart>
              </div>
              <div
                class="no-data-message"
                *ngIf="!showEthnicityDistributionChart"
              >
                <p>No data available</p>
              </div>
            </div>

            <div class="events-lists">
              <div class="graph-header">
                <h2>Gender distribution</h2>
                <h4
                  *ngIf="dataLoaded && appliedStartDate && appliedEndDate"
                  class="h4-class"
                >
                  {{ appliedStartDate | date: "dd/MM/yyyy" }} -
                  {{ appliedEndDate | date: "dd/MM/yyyy" }}
                </h4>
              </div>
              <div
                *ngIf="showGenderDistributionChart && genderDistributionChart"
              >
                <app-universal-chart
                  [options]="genderDistributionChart"
                ></app-universal-chart>
              </div>

              <div class="no-data-message" *ngIf="!showGenderDistributionChart">
                <p>No gender data available</p>
              </div>
            </div>
          </div>
          <div class="events-lists">
            <div class="graph-header">
              <h2>Age distribution</h2>
              <h4 *ngIf="dataLoaded && startDate && endDate" class="h4-class">
                {{ startDate | date: "dd/MM/yyyy" }} -
                {{ endDate | date: "dd/MM/yyyy" }}
              </h4>
            </div>
            <div *ngIf="showAgeDistributionChart && ageDistributionChart">
              <app-universal-chart
                [options]="ageDistributionChart"
              ></app-universal-chart>
            </div>

            <div class="no-data-message" *ngIf="!showAgeDistributionChart">
              <p>No age data available</p>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="activeTab === 'Attendance trend analysis'">
        <div class="attendance-analysis-container">
          <div class="events-lists" [ngClass]="activeTabClass">
            <div class="graph-header">
              <h2>Attendance trend over time</h2>
              <h4 *ngIf="dataLoaded && appliedStartDate && appliedEndDate">
                {{ appliedStartDate | date: "dd/MM/yyyy" }} -
                {{ appliedEndDate | date: "dd/MM/yyyy" }}
              </h4>
            </div>
            <div class="chart-wrapper" style="width: 100%">
              <div
                *ngIf="!showNoDataAttendanceTrendChart && attendanceTrendChart"
              >
                <app-universal-chart [options]="attendanceTrendChart">
                </app-universal-chart>
              </div>
              <div
                class="no-data-message"
                *ngIf="showNoDataAttendanceTrendChart"
              >
                <p>No data available</p>
              </div>
            </div>
          </div>

          <div class="events-lists" [ngClass]="activeTabClass">
            <div class="graph-header">
              <h2>Attendance success rate</h2>
            </div>
            <div class="radial-chart-container" style="width: 100%">
              <div
                *ngIf="
                  !showNoDataAttendanceSuccessRateChart &&
                  attendanceSuccessRateChart
                "
              >
                <app-universal-chart [options]="attendanceSuccessRateChart">
                </app-universal-chart>
              </div>
              <div
                class="no-data-message"
                *ngIf="showNoDataAttendanceSuccessRateChart"
              >
                <p>No data available</p>
              </div>
            </div>
          </div>
        </div>

        <div class="events-lists full-width" [ngClass]="activeTabClass">
          <div class="graph-header">
            <h2>Attendance by event type</h2>
            <h4 *ngIf="dataLoaded && appliedStartDate && appliedEndDate">
              {{ appliedStartDate | date: "dd/MM/yyyy" }} -
              {{ appliedEndDate | date: "dd/MM/yyyy" }}
            </h4>
          </div>
          <div
            class="chart-wrapper"
            style="min-height: 480px; width: 100%; overflow-x: auto"
          >
            <div
              *ngIf="
                !showNoDataAttendanceByEventTypeChart &&
                attendanceByEventTypeChart
              "
            >
              <app-universal-chart [options]="attendanceByEventTypeChart">
              </app-universal-chart>
            </div>
            <div
              class="no-data-message"
              *ngIf="showNoDataAttendanceByEventTypeChart"
            >
              <p>No data available</p>
            </div>
          </div>
        </div>
      </div>

      <div class="grid-graph-region" *ngIf="activeTab === 'Reports dashboard'">
        <div class="events-lists">
          <div class="graph-header">
            <h2>Events by event manager</h2>
            <h4 *ngIf="dataLoaded && startDate && endDate">
              {{ startDate | date: "dd/MM/yyyy" }} -
              {{ endDate | date: "dd/MM/yyyy" }}
            </h4>
          </div>
          <div class="chart-scroll" *ngIf="!showNoDataEventManagerChart">
            <div id="manager-chart"></div>
          </div>
          <div class="no-data-message" *ngIf="showNoDataEventManagerChart">
            <p>No data available</p>
          </div>
        </div>

        <div class="events-lists">
          <div class="graph-header">
            <h2>Events by region</h2>
            <h4
              *ngIf="
                startDate && endDate && activeTab + '' !== 'School engagement'
              "
            >
              {{ startDate | date: "dd/MM/yyyy" }} -
              {{ endDate | date: "dd/MM/yyyy" }}
            </h4>
          </div>
          <div class="chart-scroll" *ngIf="!showNoDataEventRegionChart">
            <div id="region-chart"></div>
          </div>
          <div class="no-data-message" *ngIf="showNoDataEventRegionChart">
            <p>No data available</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="spinner" *ngIf="loading"></div>

  <div
    *ngIf="
      activeTab !== 'Reports dashboard' &&
      activeTab !== 'Diversity' &&
      activeTab !== 'Attendance trend analysis'
    "
    [style.opacity]="loading ? 0 : 1"
    [style.height]="loading ? 0 : 'auto'"
    style="overflow: hidden; transition: 0.5s ease"
  >
    <div
      class="table-card"
      [ngClass]="{ 'report-tab': activeTab === 'Event report' }"
    >
      <div class="table-card-name">
        {{
          activeTab === "Event report"
            ? "Event list"
            : activeTab === "Event type report"
              ? "Event type list"
              : activeTab === "Manager activity"
                ? "Event manager list"
                : activeTab === "Industry partner"
                  ? "Partner name list"
                  : activeTab === "MCC event partner"
                    ? "Partner activity list"
                    : activeTab === "School engagement"
                      ? "School list"
                      : ""
        }}
      </div>
      <app-table
        [columns]="
          activeTab === 'Reports dashboard'
            ? []
            : activeTab === 'Event report'
              ? eventReportTable
              : activeTab === 'Event type report'
                ? eventTypeTable
                : activeTab === 'Manager activity'
                  ? totalEventsManaged
                  : activeTab === 'Industry partner'
                    ? industryPartnerTable
                    : activeTab === 'MCC event partner'
                      ? partnerEngagement
                      : activeTab === 'School engagement'
                        ? engagementSchool
                        : []
        "
        [data]="paginatedTableData"
        [loading]="loading"
        [tableName]="activeTab"
        [serverSidePagination]="true"
        [totalItems]="totalTableItems"
        [currentPage]="currentTablePage"
        [pageSize]="pageSize"
        (pageChange)="onTablePageChange($event)"
        (sortClick)="onSortChange($event)"
        [sortColumn]="sortColumn"
        [sortDirection]="sortDirection"
        [sortableColumns]="getCurrentTableColumns()"
      >
      </app-table>
    </div>
  </div>
</div>
